import {
	Button,
	List,
} from 'antd';
import {
	formatPrice,
	sponsorTierStatus,
} from '../../utilities';
import {
	SettingsLoading,
	useTournamentSettings,
} from './useTournamentSettings';

function SponsorName({sponsor}) {
	if (!sponsor.url) {
		return sponsor.name;
	}

	return <a href={ sponsor.url } target="_blank" rel="noopener noreferrer">{ sponsor.name }</a>;
}

function TierTitle({tier}) {
	const {remaining, showsRemaining, sponsoredInTitle, soldOut} = sponsorTierStatus(tier);

	if (sponsoredInTitle) {
		return <span>{ tier.name } - <em>Sponsored by</em> <SponsorName sponsor={ tier.sponsors[0] } /></span>;
	}
	if (soldOut) {
		return <span>{ tier.name } - Sold out</span>;
	}

	return <span>{ tier.name }{ showsRemaining && ` (${ remaining } remaining)` } - { formatPrice(tier.price) }</span>;
}

export function Sponsor() {
	const {settings, failed} = useTournamentSettings();

	if (!settings) {
		return <SettingsLoading failed={ failed } />;
	}

	const {interestFormUrl, tiers} = settings.sponsors;

	return (
		<>
			<h1>Event Sponsors</h1>
			<p>
				There are many opportunities to partner with the Nora Mae Budge Foundation as a sponsor of this event.
			</p>
			<p>
				<strong>
					All net proceeds will be donated to help children with congenital heart disease and their families at&nbsp;
					<a href="https://intermountainhealthcare.org/primary-childrens" target="_blank" rel="noreferrer">Primary Children's Hospital</a>
					&nbsp;through the&nbsp;
					<a href="https://intermountainhealthcare.org/giving-volunteering/intermountain-foundation/about-us/" target="_blank" rel="noreferrer">Intermountain Foundation</a>.
				</strong>
			</p>
			<p>
				Your sponsorship will help us make an even greater impact in the lives of these children!
			</p>

			<hr />

			<p>
				<strong>Note: </strong>
				All donations, including sponsorship donations, are handled by The Nora Mae Budge Foundation, which is a 501(c)(3) non-profit organization.
			</p>
			<p>
				Please send all sponsorship questions to <a href="mailto:info@forenora.com">info@forenora.com</a> — Thank you!
			</p>

			<p>
				Interested in sponsoring? Fill out our quick form and we'll be in touch:
			</p>
			<p>
				<a href={ interestFormUrl } target="_blank" rel="noopener noreferrer">
					<Button type="primary" size="large">Become a Sponsor</Button>
				</a>
			</p>

			<List
				bordered={ true }
				dataSource={ tiers }
				size="large"
				header={ <h2>Sponsorship Opportunities</h2> }
				itemLayout="vertical"
				renderItem={ (tier) => (
					<List.Item>
						<h3><TierTitle tier={ tier } /></h3>
						{ sponsorTierStatus(tier).listsSponsors && (
							<p>
								<em>Sponsored by</em>&nbsp;
								{ tier.sponsors.map((sponsor, index) => (
									<span key={ index }>
										{ index > 0 && ', ' }
										<SponsorName sponsor={ sponsor } />
									</span>
								)) }
							</p>
						) }
						<p>{ tier.description }</p>
						{ tier.benefits && !!tier.benefits.length && (
							<ul>
							{ tier.benefits.map((benefit, index) => (
								<li key={ index }>{ benefit }</li>
							)) }
						</ul>
						) }
					</List.Item>
				) }
			/>
			<br />
			<h3>
				None of these options work? Send us a message at&nbsp;
				<a href="mailto:info@forenora.com">info@forenora.com</a>
				&nbsp;and let's figure something out! We would love to work with you.
			</h3>
			<p>
				Ready to get involved?&nbsp;
				<a href={ interestFormUrl } target="_blank" rel="noopener noreferrer">Become a Sponsor</a>
				&nbsp;by filling out our interest form.
			</p>
		</>
	)
}
